<template>
  <el-select
    :allow-create="!isSingapore"
    clearable
    filterable
    style="width: 100%"
    v-model="formattedLocationLevel"
    @change="handleLocationChange"
    :disabled='disabled'
    @visible-change="handleSelectVisibleChange"
  >
    <el-option
      v-for="location in isSingapore ? sgpLocationList : otherLocationList"
      :key="location.key"
      :label="location.label"
      :value="location.value"
    >
      <div class="" v-if="!isSingapore">
        <span>{{ location.label }}</span> 
        <span style="cursor: pointer; float: right;">
          <em class="el-icon-remove"@click.stop="deleteLocation(location.key)"></em>
        </span>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { getLocationByCountry,addLocationByCountry,delLocationByCountry } from "@/services/modules";
export default {
  name: 'JobLocationSelector',
  props: {
    disabled:{
      type: Boolean,
      default: false
    },
    schedulFormData: Object,
  },
  data(){
    return {
      locationList: this.$store.state.locationList,
      sgpLocationList: this.$store.state.sgpLocationList,
      otherLocationList:[],
      mappedCountryList: this.$store.state.mappedCountryList,
    }
  },
  watch: {
    'schedulFormData.timezone'(newVal) {
      if(this.isSingapore){
        this.otherLocationList = this.sgpLocationList
      }else{
        this.getLocationListByCountry()
      }
    }
  },
  computed:{
    formattedLocationLevel: {
      get() {
        return this.schedulFormData.locationLevel2
      },
      set(val) {
        this.schedulFormData.locationLevel2 = val 
        this.$emit('handleChangeLocation',this.schedulFormData.locationLevel2)
      }
    },
    isSingapore(){
      return this.schedulFormData.timezone === "Asia/Singapore" || !this.schedulFormData.timezone;
    },
  },
  mounted(){
    this.schedulFormData.country =  this.schedulFormData.country ?  this.schedulFormData.country : "SGP"
  },
  methods:{
    getMatchedCountry(){
      const match = this.mappedCountryList.find(opt => opt.value === this.schedulFormData.timezone);
      return match ?? null;
    },
    handleSelectVisibleChange(visible) {
      if (visible && !this.isSingapore) {
        this.getLocationListByCountry();
      }
    },
    getLocationListByCountry(){
      if(this.isSingapore || !this.schedulFormData.country){
        return
      }
      const match = this.getMatchedCountry()
      const countryCode = match ? match.countryCode : null;
      getLocationByCountry(countryCode).then(res => {
        if(res){
          this.otherLocationList = res.data.map(loc => ({
            value: loc.locationCode,
            label: loc.locationCode,
            key: loc.id
          }));
        }
      })
    },
    handleLocationChange(value) {
      if(this.isSingapore){
        return
      }
      this.formattedLocationLevel = value.toUpperCase();
      const match = this.getMatchedCountry();
      const exists = this.otherLocationList.some(loc => loc.value.toUpperCase() === value.toUpperCase());
      if (!exists && value) {
        const data = {
          "locationCode": value.toUpperCase(),
          "countryId": match.key
        }
        addLocationByCountry(data).then(res => {
          if (res.code === 1000) {
            this.$message.success('Location added successfully');
            this.getLocationListByCountry();
          } else {
            this.$message.error('Failed to add location');
          }
        })
      }
    },
    deleteLocation(locationId){
      const location = this.otherLocationList.find(loc => loc.key === locationId);
      if (!location) return;

      const selectedValue = this.formattedLocationLevel;
      if (selectedValue === location.value) {
        this.formattedLocationLevel = null;
        this.$emit('handleChangeLocation', null);
      }

      delLocationByCountry(locationId).then(res => {
        if (res.code === 1000) {
          this.$message.success('Location removed successfully');
          this.getLocationListByCountry();
        } else {
          this.$message.error('Failed to remove location');
        } 
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.header, .body {
  display: grid;
  column-gap: 10px;
  grid-template-columns: 2fr 1fr 1fr
}
.header{
  padding:10px;
  span{
    display: inline-block;
    font-size: 14px;
    font-weight: 500;
  }
 }
.body{
  span{
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
  }
 }

@media screen and (max-width: 599px) {
  .header{
    span{
      font-size: 12px;
    }
  }
  .body{
      span{
        font-size: 11px;
      }
  }
}

</style>
